import React, { FC } from 'react';
import { usePlaybackStore } from './playbackStore';

interface Props {
    formatTime: (sec: number) => string;
}

/** 仅时间数字区域订阅 currentTime，父组件不随播放时钟刷新 */
export const VideoEditPlaybackTimeDisplay: FC<Props> = ({ formatTime }) => {
    const currentTime = usePlaybackStore((s) => s.currentTime);
    return <>{formatTime(currentTime)}</>;
};
